import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import PageTitle from "@/components/ui/page-title";

const DashboardPage = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        navigate("/");
    };

    return (
        <>
            <Helmet>
                <title>Dashboard - MoovaTV</title>
                <meta name="description" content="Dashboard do MoovaTV." />
            </Helmet>

            <div className="flex flex-col items-center justify-center h-screen">
                <PageTitle className="mb-6">Dashboard</PageTitle>
                <p className="text-gray-500 mt-2 mb-6">
                    Você está conectado.
                </p>
                <div className="flex items-center justify-center gap-4">
                    <Button onClick={() => navigate("/")} variant="outline">
                        Voltar ao início
                    </Button>
                    <Button onClick={handleLogout}>
                        Sair
                    </Button>
                </div>
            </div>
        </>
    )
};

export default DashboardPage;
